import React, { useContext } from 'react';
import { Col, Row } from 'react-bootstrap';
import { LocalizationContext } from '../../../context/LangChange';

const translations = {
    en: require('../../../Translate/en.json').VisualProduction.SocialMediaSection2,
    ar: require('../../../Translate/ar.json').VisualProduction.SocialMediaSection2,
};

const SocialMediaSection2 = () => {
    const { isLang } = useContext(LocalizationContext);
    const t = translations[isLang || 'en'];

    const sections = ["MotionVideoProduction", "ReelsProduction", "GraphicDesignForVideo"];

    return (
        <div className="social-media-section  d-flex">
            {sections.map((section, index) => (
                <Col xl={4} md={4} sm={12} xs={12} key={index} >
                    <div className="card"> 
                        <h3>{t[section].title}</h3>
                        <ul>
                            {[1, 2, 3].map((num) =>
                                t[section][`description${num}`] ? (
                                    <li key={num}>{t[section][`description${num}`]}</li>
                                ) : null
                            )}
                        </ul>
                    </div>
                </Col>
            ))}
        </div>
    );
};

export default SocialMediaSection2;
